import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchSubscriber } from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import utilities
import { submitForm } from 'components/utilities/form';

// Validate
import validate from './validation';

// Import variables
import { SUBSCRIBER_SOURCE_TYPES } from 'components/helpers/variables';

// Import components
import { FormTemplate } from 'components/common/templates';
import { FormButtons } from 'components/common/buttons';
import Fields from './fields/Fields';
import SubscribersButtons from './SubscribersButtons';

const SubscribersForm = ({
	history,
	fetchSubscriber,
	error,
	isLoaded,
	initialValues
}) => {
	const { t } = useTranslation();

	const isPureOttSubscriber =
		initialValues?.source === SUBSCRIBER_SOURCE_TYPES.PURE_OTT;

	const isFirebaseSubscriber =
		initialValues?.source === SUBSCRIBER_SOURCE_TYPES.FIREBASE;

	const isSubscribersButtonsVisible =
		isPureOttSubscriber || isFirebaseSubscriber;

	const handleOnSubmit = ({ isEdit, itemID }) => async (values) => {
		// credits_limits is useless value in this project, so value is equal 0 to avoid validation error from API
		const resources = { ...values, credits_limit: 0 };

		// Submit the form with field values
		return await submitForm({
			history,
			isEdit,
			itemID,
			resources,
			api: 'subscriber',
			redirectPath: 'subscribers'
		});
	};

	return (
		<>
			{isSubscribersButtonsVisible && (
				<SubscribersButtons
					subscriberData={initialValues}
					isFirebaseSubscriber={isFirebaseSubscriber}
				/>
			)}
			<FormTemplate
				fetchResourceToEdit={fetchSubscriber}
				error={error}
				isLoaded={isLoaded}
			>
				{({ isEdit, itemID, decorators }) => (
					<Form
						initialValues={initialValues}
						validate={validate}
						decorators={decorators}
						onSubmit={handleOnSubmit({ isEdit, itemID })}
						render={({ handleSubmit, submitting }) => (
							<form onSubmit={handleSubmit}>
								<Fields isEdit={isEdit} submitting={submitting} />
								<FormButtons
									isButtonDisabled={submitting || error}
									path="subscribers"
									buttonText={t('common:buttons.submit')}
								/>
							</form>
						)}
					/>
				)}
			</FormTemplate>
		</>
	);
};

SubscribersForm.propTypes = {
	history: PropTypes.object.isRequired,
	initialValues: PropTypes.object.isRequired,
	fetchSubscriber: PropTypes.func.isRequired,
	error: PropTypes.bool.isRequired,
	isLoaded: PropTypes.bool.isRequired
};

const mapStateToProps = ({ subscribers: { form } }) => ({
	initialValues: form.edit,
	error: form.error,
	isLoaded: form.isLoaded
});

export default compose(
	connect(mapStateToProps, { fetchSubscriber }),
	withRouter
)(SubscribersForm);
